/* eslint-disable max-params */
/* eslint-disable no-shadow */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
/* eslint-disable curly */
import { HttpClient } from "@angular/common/http"
import { inject, Injectable, signal } from "@angular/core"
import { AuthService } from "../../01_core/auth/auth.service";
import { environment } from "../../../environments/environment";
import { ManufacturingOrderModel } from "./manufacturing-order.model";
import { KeyValueTimeCache } from "../../01_core/tools/key-value-time-cache";
import { firstValueFrom, map } from "rxjs";

const tenantID = 'tebisInternalTenant';

export function mapOrderIn(order: ManufacturingOrderModel) {
  if (order.createdAt) order.createdAt = new Date(order.createdAt);
  if (order.deliveryDate) order.deliveryDate = new Date(order.deliveryDate);
  return order;
}

@Injectable({ providedIn: 'root' })
export class ManufacturingOrderService {

  http = inject(HttpClient);
  authService = inject(AuthService);
  authorizedHttp = this.authService.authorize(this.http);

  ordersList = signal(<ManufacturingOrderModel[]>[]);
  idCache = new KeyValueTimeCache<string, ManufacturingOrderModel>(5000, (order) => order.id);

  public getOrders(lastKey: any, limit: number, query: string, sortKey: string, sortDirection: 'asc'|'desc') {
    sortKey ||= 'createdAt';
    const queryParams = [`tenantID=${tenantID}`];
    queryParams.push(
      `limit=${limit}`,
      `sortKey=${sortKey}`,
      `sortDir=${sortDirection}`
    );
    if (query) {
      queryParams.push(query);
    }
    if (lastKey) {
      queryParams.push(`lastKey=${encodeURIComponent(JSON.stringify(lastKey))}`);
    }
    return this.authorizedHttp.get<{ lastKey: any, orders: ManufacturingOrderModel[] }>(`${environment.baseUrl}/order?${queryParams.join('&')}`).pipe(map(data => {
      data.orders.forEach(p => {
        mapOrderIn(p);
      });
      return data;
    }));
  }

  getOrderByID(id: string) {
    // Causes a bug when opening the overview of one order: Sidenav does not open
    // if (this.idCache.has(id)) { return this.idCache.get(id); }

    const queryParams = [`tenantID=${tenantID}`];
    this.authorizedHttp.get<ManufacturingOrderModel>(`${environment.baseUrl}/order/${id}?${queryParams.join('&')}`).subscribe((order) => {
      order.deliveryDate = new Date(order.deliveryDate);
      this.idCache.set(order);
    });
    return this.idCache.getAnyways(id);
  }

  getOrdersByIDs(ids: (string | null)[] | null) {
    if (!ids) { return []; }
    const filteredIDs = ids.filter(Boolean) as string[];
    const orders = filteredIDs.map(id => this.getOrderByID(id));
    return orders;
  }

  getOrderByIDFromCache(id: string) {
    return this.idCache.getAnyways(id);
  }

  async createOrder(order: Partial<ManufacturingOrderModel>) {
    const queryParams = [`tenantID=${tenantID}`];
    const createdOrder = await firstValueFrom(this.authorizedHttp.post<ManufacturingOrderModel>(`${environment.baseUrl}/order?${queryParams.join('&')}`, order));
    mapOrderIn(createdOrder);
    this.idCache.set(createdOrder);
    return createdOrder;
  }

  patchOrder(id: string, patch: Partial<ManufacturingOrderModel>) {
    if (patch.deliveryDate) {
      (<any>patch.deliveryDate) = new Date(patch.deliveryDate).getTime();
    }
    const queryParams = [`tenantID=${tenantID}`];
    this.authorizedHttp.patch<object>(`${environment.baseUrl}/order/${id}?${queryParams.join('&')}`, patch).subscribe(() => {
      const order = this.idCache.getAnyways(id)?.();
      if (order) {
        this.idCache.set({
          ...order,
          ...patch,
          id,
        });
      }
    });
  }

  deleteOrder(order: ManufacturingOrderModel) {
    const queryParams = [`tenantID=${tenantID}`];
    this.authorizedHttp.delete(`${environment.baseUrl}/order/${order.id}?${queryParams.join('&')}`).subscribe();
  }
}
